module.exports = __webpack_public_path__ + "img/994.289f97b6.png";